export default {
    create_diagnostic_device_title: "Crear Diagnóstico",
    create_diagnostic_device_create: "Crear",
    create_diagnostic_device_transaction_request_message:"Se ha recibido la solicitud de diagnóstico de dispositivos. Haga clic aquí para ver el estado del diagnóstico.",

    create_diagnostic_device_the_device_has_not_been_found: "No se ha encontrado el dispositivo",
    create_diagnostic_device_the_device_has_already_been_added: "El dispositivo ya ha sido añadido",
    create_diagnostic_device_the_devices_has_already_been_added: "algunos dispositivos ya se agregaron a la lista",
    create_diagnostic_device_the_unit_type_of_the_device_must_bet_the_same: "El tipo de unidad de los dispositivos debe ser el mismo",
    create_diagnostic_device_the_manufacturer_of_the_devices_must_be_the_same: "El fabricante de los dispositivos debe ser el mismo",
    create_diagnostic_device_imei_or_serial: "IMEI o Serial",
    create_diagnostic_device_imei: "IMEI",
    create_diagnostic_device_serial: "Serial",
    create_diagnostic_device_model: "Modelo",
    create_diagnostic_device_commands_sent: "Comandos enviados",
    create_diagnostic_device_status: "Estado",
    create_diagnostic_device_complete: "Completado",
    create_diagnostic_device_send_more_commands: "Enviar más comandos",
    create_diagnostic_device_mass_sms_title: "SMS Masivos",
    
    create_diagnostic_device_command_to_send: "Comando a Enviar",
    create_diagnostic_device_canned_commands: "Comandos",
    create_diagnostic_device_phone_numbers: "Números de Teléfono",
    create_diagnostic_device_unit_type: "Tipo de Unidad",
    create_diagnostic_device_error_phone_length: "El número de teléfono no tiene entre 10 y 15 digitos",
    create_diagnostic_device_error_phone_not_number: "El número de teléfono no es un numero valido",
    create_diagnostic_device_send_type: "Tipo de Envío",
    create_diagnostic_device_unvalid_phone_numbers: "No hay números de teléfonos validos para el enviar el comando",
    create_diagnostic_device_errors: "Errores",
    create_diagnostic_device_sent: "Comando enviado a",
    create_diagnostic_device_error_duplicate_phone: "Número de teléfono duplicado",
}